import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { MenuService } from '../../menu.service';

@Component({
	selector: 'app-menu-template5',
	templateUrl: './menu-template5.component.html',
	styleUrls: ['./menu-template5.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuTemplate5Component implements OnInit {

  public year : number = Date.now();
  userLogin: boolean;
	constructor(private authService: AuthService, private router: Router, private menuService: MenuService) {
		this.userLogin = authService.isToken();
	}

	ngOnInit() {
	}


	onRegresar() {
		if (this.menuService.getRoles().horizontal && this.menuService.getRoles().horizontal.length > 0) {
			this.router.navigate([this.menuService.getRoles().horizontal[0].ruta_url]);
		} else {
			this.router.navigate(['/perfil']);
		}
	}

  onOLClick() {
		window.open('http://www.confecamaras.org.co');
	}

}
